import { render } from "./PricingPage.vue?vue&type=template&id=5f14e63a&scoped=true&ts=true"
import script from "./PricingPage.vue?vue&type=script&lang=ts"
export * from "./PricingPage.vue?vue&type=script&lang=ts"

import "./PricingPage.vue?vue&type=style&index=0&id=5f14e63a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f14e63a"]])

export default __exports__